export default "__VITE_ASSET__dejMgnaO__"